import loginApi from "../services/loginApi";


export const useInitiateHandshake = () => {
    const api = new loginApi();

    const initiateHandshake = async (body, url = false, filter = false) => {

        try {
            const response = await api.initiateToken(body);
            const { success, data = {} } = response?.data || {};

            if (success) { 
                /********* commenting for now, need to confirm *******/
                // if(url) {
                //     if(url.includes('/sso')) {
                //         window.location.href = `${process.env.REACT_APP_MF_DATALAKE_URL}/${url}?ctx=${data?.token}`;
                //     } else {
                //         window.location.href = `${process.env.REACT_APP_MF_DATALAKE_URL}/v2/sso?ctx=${data?.token}`;
                //     }
                // } else {
                //     window.location.href = `${process.env.REACT_APP_MF_DATALAKE_URL}?ctx=${data?.token}`;    
                // }
                if(filter === "PMS") {
                    window.location.href = `${process.env.REACT_APP_MOTILAL_PMS_MODULE_URL}/sso?ctx=${data?.token}`;
                    return;
                } else if (filter === "AIF") {
                    window.location.href = `${process.env.REACT_APP_MOTILAL_AIF_MODULE_URL}/sso?ctx=${data?.token}`;
                    return;
                }

                //MF Datalake Redirection
                window.location.href = `${process.env.REACT_APP_MF_DATALAKE_URL}/sso?ctx=${data?.token}`;
            }
        } catch (err) {
            return { success: false, error: err.message };
        }
    };

    return {
        initiateHandshake,
    };
};
